export const visit = (vm, at) => {
at({ "fr": { "hc-0133": { "sample-data-banner": { "title": "Mode d'\xE9chantillon de donn\xE9es", "description": "Vous pouvez consulter et modifier ces donn\xE9es jusqu'\xE0 ce que vous soyez pr\xEAt \xE0 charger les v\xF4tres." } } } });
};